import React, { Component } from 'react'
import Card from '../Card'
import './ProgressBar.scss'

class ProgressBar extends Component {
  constructor(props) {
    super(props)
    this.handleScroll = this.handleScroll.bind(this)
    this.state = {
      show: false,
      progress: 0,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll(event) {
    let progress =
      ((window.scrollY - this.props.headerOffSet) / this.props.postBodyHeight) *
      100
    progress = Math.min(100, Math.max(0, progress))

    if (window.scrollY > this.props.headerOffSet) {
      this.setState({ show: true, progress })
    } else {
      this.setState({ show: false, progress })
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  render() {
    let typeIcon = this.props.typeIcon || 'fa-file-text-o'
    let toTop = this.props.toTop == 'false' ? false : true
    return (
      <div className={this.state.show ? 'progress-bar show' : 'progress-bar'}>
        <div className="progress-bar-container">
          {this.props.link ? (
            <a className="progress-bar-container-info" href={this.props.link}>
              <i className={`fa ${typeIcon}`}></i> {this.props.type}
            </a>
          ) : (
            <span className="progress-bar-container-info">
              <i className={`fa ${typeIcon}`}></i> {this.props.type}
            </span>
          )}
          <div className="progress-bar-title">
            <span className="light heading-2">{this.props.title}</span>
          </div>
          {this.props.subtitle ? <span>{this.props.subtitle}</span> : null}
          {toTop ? (
            <a className="to-top" onClick={this.scrollToTop}>
              Back to top <i className={`fa fa-caret-up`}></i>
            </a>
          ) : null}
        </div>
        <div
          className="progress"
          style={{ width: this.state.progress + '%' }}
        ></div>
      </div>
    )
  }
}

export default ProgressBar
